import { isNil } from 'lodash-es'

export const MULTIPLE_VALUES = ''

export const NEW_ITEM_PREFIX = 'new-item'

export const notEmpty = (s: string | null | undefined) => !isNil(s) && s.trim() !== ''

export const splitString = (s: string, chunkLength: number) => {
  const numChunks = Math.ceil(s.length / chunkLength)
  const chunks = new Array(numChunks)

  for (let i = 0, j = 0; i < numChunks; i++, j += chunkLength) {
    chunks[i] = s.substr(j, chunkLength)
  }

  return chunks
}

export function isMajorVersionBump(version1: string, version2: string): boolean {
  const majorVersion1 = version1.split('.').shift()
  const majorVersion2 = version2.split('.').shift()

  if (!majorVersion1) {
    throw new Error(`Invalid version string [${majorVersion1}]`)
  }
  if (!majorVersion2) {
    throw new Error(`Invalid version string [${majorVersion2}]`)
  }
  return parseInt(majorVersion1, 10) < parseInt(majorVersion2, 10)
}

export function sliceFieldName(fieldName: string, slicePosition: number): string {
  return fieldName
    .split('.')
    .slice(slicePosition)
    .join('.')
}

const collator = new Intl.Collator(undefined, { sensitivity: 'base' })

export function compareInsensitive(str1: string, str2: string, ignoreWhitespace: boolean = false): number {
  return collator.compare(ignoreWhitespace ? str1.replace(/\s+/g, '') : str1, ignoreWhitespace ? str2.replace(/\s+/g, '') : str2)
}
